import React, { Component } from 'react';
import axios from 'axios';
import Moment from 'react-moment';
import 'moment-timezone';
import queryString from 'query-string';

// Components
import VideoList from '../components/singlets/VideoList';

export class Event extends Component  {
  state = {
    isLoaded: false, video: [], videoid: null
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.querySelector('#main').classList.remove('hero');

    const googleAPI = process.env.REACT_APP_GOOGLEAPI;
    const googleAPI_Key = process.env.REACT_APP_GOOGLEAPIKEY;
    let url = window.location.search;
    let params = queryString.parse(url);
    let videoId = params.videoid;

    axios.get(googleAPI+'/videos', {
      params: {
        part: 'snippet,id',
        key: googleAPI_Key,
        id: videoId
      }
    })
    .then(res => {
      this.setState({ video: res.data.items[0].snippet, videoid: res.data.items[0].id, isLoaded: true })
      // console.dir(res);
    });
  }

  render() {
    const { isLoaded, video, videoid } = this.state;
    // console.dir(this.state);

    return (
      <>
        <div className="pageContent">
          <div className="container">
            <div className="row">

              {isLoaded && (
                <>
                  <div className="col-9 contentCont">

                    <h1>{ video.title }</h1>
                    <p className="dateTime">
                      <Moment date={ video.publishedAt } format='dddd, MMMM DD, YYYY' />
                    </p>

                    <div className="videoPlayer">
                      <iframe title="title" src={ 'https://www.youtube.com/embed/' + videoid } frameBorder="0" />
                    </div>

                    <div className="description">
                      <p>{ video.description }</p>
                    </div>
                  </div>

                  <div className="col-3">
                    <VideoList count="10" />
                  </div>
                </>
              )}

            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Event;